"use client";

import { c as _c } from "react/compiler-runtime";
import { useContext, useEffect, useState } from "react";
import type { ApiProfileRepRatesState, RatingStats } from "@/entities/IProfile";
import UserPageRepRepsTable from "./table/UserPageRepRepsTable";
import { AuthContext } from "@/components/auth/Auth";
import { ApiProfileProxyActionType } from "@/generated/models/ApiProfileProxyActionType";
import type { ApiIdentity } from "@/generated/models/ApiIdentity";
import UserPageRateWrapper from "../../utils/rate/UserPageRateWrapper";
import UserPageRepNewRep from "../new-rep/UserPageRepNewRep";
import { RateMatter } from "@/types/enums";
export default function UserPageRepReps(t0) {
  const $ = _c(36);
  const {
    repRates,
    profile
  } = t0;
  const {
    connectedProfile,
    activeProfileProxy
  } = useContext(AuthContext);
  const sortReps = _temp2;
  let t1;
  if ($[0] !== repRates?.rating_stats) {
    t1 = repRates?.rating_stats ?? [];
    $[0] = repRates?.rating_stats;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = sortReps(t1);
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const [reps, setReps] = useState(t2);
  let t3;
  if ($[4] !== repRates?.rating_stats) {
    t3 = () => setReps(sortReps(repRates?.rating_stats ?? []));
    $[4] = repRates?.rating_stats;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const t4 = repRates?.rating_stats;
  let t5;
  if ($[6] !== t4) {
    t5 = [t4];
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  useEffect(t3, t5);
  let t6;
  if ($[8] !== activeProfileProxy || $[9] !== profile) {
    t6 = t7 => {
      const {
        myProfile,
        targetProfile
      } = t7;
      if (!myProfile?.handle) {
        return false;
      }
      if (activeProfileProxy) {
        if (profile.handle === activeProfileProxy.created_by.handle) {
          return false;
        }
        return activeProfileProxy.actions.some(_temp3);
      }
      if (myProfile.handle === targetProfile.handle) {
        return false;
      }
      return true;
    };
    $[8] = activeProfileProxy;
    $[9] = profile;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const getCanEditRep = t6;
  let t7;
  if ($[11] !== connectedProfile || $[12] !== getCanEditRep || $[13] !== profile) {
    t7 = getCanEditRep({
      myProfile: connectedProfile,
      targetProfile: profile
    });
    $[11] = connectedProfile;
    $[12] = getCanEditRep;
    $[13] = profile;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  const [canEditRep, setCanEditRep] = useState(t7);
  let t8;
  if ($[15] !== connectedProfile || $[16] !== getCanEditRep || $[17] !== profile) {
    t8 = () => {
      setCanEditRep(getCanEditRep({
        myProfile: connectedProfile,
        targetProfile: profile
      }));
    };
    $[15] = connectedProfile;
    $[16] = getCanEditRep;
    $[17] = profile;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== connectedProfile || $[20] !== profile) {
    t9 = [connectedProfile, profile];
    $[19] = connectedProfile;
    $[20] = profile;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  useEffect(t8, t9);
  let t10;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <div className="tw-mb-4"><h3 className="tw-mb-0 tw-text-xl tw-font-semibold tw-text-iron-100">Total Rep</h3></div>;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== profile || $[24] !== repRates) {
    t11 = <UserPageRepNewRep profile={profile} repRates={repRates} />;
    $[23] = profile;
    $[24] = repRates;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== profile || $[27] !== t11) {
    t12 = <UserPageRateWrapper profile={profile} type={RateMatter.REP} hideOwnProfileMessage={true}>{t11}</UserPageRateWrapper>;
    $[26] = profile;
    $[27] = t11;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[29] !== canEditRep || $[30] !== profile || $[31] !== reps) {
    t13 = !!reps.length && <div className="tw-mt-2"><UserPageRepRepsTable reps={reps} profile={profile} canEditRep={canEditRep} /></div>;
    $[29] = canEditRep;
    $[30] = profile;
    $[31] = reps;
    $[32] = t13;
  } else {
    t13 = $[32];
  }
  let t14;
  if ($[33] !== t12 || $[34] !== t13) {
    t14 = <div className="tw-mt-6 lg:tw-mt-8"><div className="tw-relative">{t10}{t12}{t13}</div></div>;
    $[33] = t12;
    $[34] = t13;
    $[35] = t14;
  } else {
    t14 = $[35];
  }
  return t14;
}
function _temp3(action) {
  return action.action_type === ApiProfileProxyActionType.AllocateRep;
}
function _temp2(items) {
  return [...items].sort(_temp);
}
function _temp(a, d) {
  if (a.rating === d.rating) {
    return d.contributor_count - a.contributor_count;
  }
  return d.rating - a.rating;
}